import { TEN_MINUTES_IN_MS } from '@/common/constants';

export const UNASSIGNED_ID = 0;

export const INSIGHTS_STALE_TIME = TEN_MINUTES_IN_MS;
